import { useAppStore } from "@store/appStateStore";

import HomeTab from "../tabs/home/HomeTab";
import ParticipantsTab from "../tabs/participants/ParticipantsTab";
import TransactionsTab from "../tabs/transactions/TransactionsTab";
import AttendancesTab from "../tabs/attendances/AttendancesTab";
import DirectionsTab from "../tabs/directions/DirectionsTab";

const Tabbar: React.FC = () => {
  const { tab } = useAppStore();

  return (
    <div className="tab-content">
      {tab === "home" && <HomeTab />}
      {tab === "participants" && <ParticipantsTab />}
      {tab === "transactions" && <TransactionsTab />}
      {tab === "attendances" && <AttendancesTab />}
      {tab === "directions" && <DirectionsTab />}
    </div>
  );
};
export default Tabbar;
